import React from "react";
import Popup from "reactjs-popup";
import "../../styles/Collapsible.scss";
import { adalApiFetch } from "../../adalConfig";
import axios from "axios";
import * as api from "../../constants/api";
import { toastError } from "../../util/CommonFunctions";
import { toastSuccess } from "../../util/CommonFunctions";
import { Button, Tooltip } from "@material-ui/core";


export default class PECNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isChecked: false,
      helperText: "",
      error: false,
      textValue: "",
      isValid: false,
      notificationBtnText: "Send Notification to PEC",
      pecNotificationSentAt: props.pecNotificationSentAt
    };
    this.openModal = this.openModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.sendPECNotification = this.sendPECNotification.bind(this);
  }

  openModal() {
    this.setState({ open: true });
  }
  closeModal() {
    this.setState({
      open: false,
      helperText: "",
      error: false,
      isValid: false,
    });
  }
  closeNotificationPopup() {
    this.setState({
      open: false,
      helperText: "",
      error: false,
      isValid: false,
    });
  }
  handleChange(event) {
    this.setState({ isChecked: event.target.checked });
  }
  onChangeText(event) {
    if (event.target.value.length > 0) {
      this.setState({
        textValue: event.target.value,
        helperText: "",
        error: false,
        isValid: true,
      });
    } else {
      this.setState({ textValue: "", isValid: false });
    }
  }
  sendPECNotification() {
    let data = {
      RegID: this.props.regID
    };
    adalApiFetch(axios, api.POST_SEND_PEC_NOTIFICATION, {
      method: "post",
      data: data,
    })
      .then((response) => {
        toastSuccess(
          "Notification email has been sent successfully to the registrant."
        );

        this.setState({
          pecNotificationSentAt: new Date(),
        });
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const errorMessage = error.message ? error.message : error.response.data;
          toastError(`Error occurred while sending email notification: ${errorMessage}.`);
        } else {
          toastError("Error occurred while sending email notification. Please try again.");
        }
      });
    this.closeModal();
  }
  render() {
    return (
      <div className="auditTrailSty">
        <Tooltip
          title={
            this.state.pecNotificationSentAt
              ? "Notification has already been sent to the registrant."
              : ""
          }
        >
          <div style={{ display: "inline-block" }}>
            <Button
              variant="contained"
              onClick={this.openModal}
              size="small"
              style={{ marginLeft: "1em" }}
              disabled={this.state.pecNotificationSentAt}
              className="auditBtn sendNotificationBtn"
            >
              Send Notification to PEC
            </Button>
          </div>
        </Tooltip>
        <Popup
          className="notifyPopup"
          open={this.state.open}
          closeOnDocumentClick
          onClose={this.closeModal}>
          <div>
            <div className="modalDivHeader">
              <button
                id="btnClose"
                onClick={this.closeModal}
                className="btn small"
                style={{ width: "20px", height: "20px", top: "0px", right: "0px" }}>
                X
              </button>
            </div>
            <center>
              <h3 className="lblNVGreen">
                Do you want to send a notification to the registrant for {this.props.regID} ?
              </h3>
            </center>
            <center style={{ marginTop: "35px" }}>
              <button
                className="btn"
                onClick={this.sendPECNotification}>
                Yes
              </button>
              <button
                className="btn"
                onClick={this.closeModal}
                style={{ marginLeft: "10px", backgroundColor: "grey" }}>
                Cancel
              </button>
            </center>
          </div>
        </Popup>
      </div >
    );
  }
}
